"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoundsLoaderExtentsBehaviour = void 0;
var olExtent = require("ol/extent");
var BoundsLoaderExtentsBehaviour = /** @class */ (function () {
    function BoundsLoaderExtentsBehaviour(_logger) {
        var _this = this;
        this._logger = _logger;
        this.reloadLayer = function (currentExtent, layer, zoom, maxFeatureCount) {
            var hasChanged = false;
            var previousExtent = null;
            var self = _this;
            //get the stored/previous extent for this layer
            for (var _i = 0, _a = self._layerExtents; _i < _a.length; _i++) {
                var lyrEx = _a[_i];
                if (lyrEx.layer.group.ref === layer.group.ref && lyrEx.layer.layerName == layer.layerName) {
                    previousExtent = lyrEx;
                    break;
                }
            }
            if (previousExtent === null) {
                hasChanged = true;
            }
            else {
                if (zoom !== previousExtent.zoomLevel && layer.group.alwaysLoadOnZoom === true) {
                    hasChanged = true;
                }
                else if (!olExtent.containsExtent(previousExtent.extent, currentExtent)) {
                    //the new extent is NOT within the old one
                    self._logger.log("".concat(layer.group.ref, " : bounds changed"));
                    hasChanged = true;
                }
                else if (zoom !== previousExtent.zoomLevel && previousExtent.featureCount === maxFeatureCount) {
                    //zoom level has changed
                    //the new bounds will be contained but re-fetch the data if the maxcount was reached last time
                    //otherwise the user won't see all the points as they zoom in
                    self._logger.log("".concat(layer.group.ref, " : zoomed in & max features"));
                    hasChanged = true;
                }
            }
            return hasChanged;
        };
        this.storeExtent = function (layer, newExtent, zoom, featureCount) {
            //find the extent help and set the new extent
            for (var _i = 0, _a = _this._layerExtents; _i < _a.length; _i++) {
                var lyrEx = _a[_i];
                if (lyrEx.layer.group.ref === layer.group.ref && lyrEx.layer.layerName == layer.layerName) {
                    lyrEx.zoomLevel = zoom;
                    lyrEx.extent = newExtent;
                    lyrEx.featureCount = featureCount;
                    return;
                }
            }
            //not returned, so add to array
            _this._layerExtents.push({
                layer: layer,
                zoomLevel: zoom,
                extent: newExtent,
                featureCount: featureCount
            });
        };
        this.clearExtent = function (layer) {
            _this.storeExtent(layer, [0, 0, 0, 0], 0, 0);
        };
        this._layerExtents = new Array();
    }
    return BoundsLoaderExtentsBehaviour;
}());
exports.BoundsLoaderExtentsBehaviour = BoundsLoaderExtentsBehaviour;
//# sourceMappingURL=BoundsLoaderBehaviour.js.map